import { Dictionary } from "vue-router/types/router";

export default class iNotPaieStorageKeys {
	public static readonly ICARE: string = "iNotPaie_icare";
	public static readonly TOKEN: string = "iNotPaie_token";
	public static readonly OAUTH_STATE: string = "iNotPaie_oauth_state";
	public static readonly USER_SOCIETE: string = "iNotPaie_user_societe";
}

export class _LocalStorageService {
	public events: Dictionary<((event: any) => any)[]> = {};

	public constructor() {
    	// this.onStorageEvent.bind(this);
    	window.addEventListener("storage", (event) => this.onStorageEvent(event));
	}

	public set(key: string, value: string): string | undefined {
    	if (!this.storageAvailable("localStorage")) {
			return;
		}
    	localStorage.setItem(key, value);
	}

	public get(key: string): string | undefined {
    	if (!this.storageAvailable("localStorage")) {
			return undefined;
		}
    	const item = localStorage.getItem(key);
    	if (item == null) {
			return undefined;
		}

    	return item;
	}

	public remove(key: string): string | undefined {
    	if (!this.storageAvailable("localStorage")) {
			return;
		}
    	localStorage.removeItem(key);
	}

	public addEvent(callback: (event) => any): void {
    	window.addEventListener("storage", callback);
	}

	public removeEvent(callback: (event) => any): void {
    	window.removeEventListener("storage", callback);
	}

	public addEventOnKey(key: string, callback: (event) => any): void {
    	if (this.events[key] == undefined) {
			this.events[key] = [callback];
		} else if (this.events[key] != undefined) {
			this.events[key].push(callback);
		}
	}

	public removeEventOnKey(key: string, callback: (event) => any): void {
    	if (this.events[key] == undefined) {
			return;
		}
    	this.events[key] = this.events[key].filter(x => x != callback);
	}

	private onStorageEvent(event: any): void {
    	if (this.events[event.key] != undefined) {
    		this.events[event.key].forEach(x => x(event));
    	}
	}

	private storageAvailable(type): any {
    	try {
    		const storage = window[type];
    		const x = "__storage_test__";
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    		// @ts-ignore
			storage.setItem(x, x);
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    		// @ts-ignore
			storage.removeItem(x);

    		return true;
    	} catch (e) {
    		return e instanceof DOMException && (
    		// everything except Firefox
    			e.code === 22 ||
                // Firefox
                e.code === 1014 ||
                // test name field too, because code might not be present
                // everything except Firefox
                e.name === "QuotaExceededError" ||
                // Firefox
                e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
                // acknowledge QuotaExceededError only if there's something already stored
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                storage.length !== 0;
    	}
	}
}

export const LocalStorageService = new _LocalStorageService();



// WEBPACK FOOTER //
// ./src/components/Controls/LocalStorageService.ts